import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    interested: "Me interesa",
    updateError: "No se pudo actualizar. Intenta de nuevo.",
    loginTitle: "Inicia sesión para marcar interés",
    loginDescription: 'Crea una cuenta gratis o inicia sesión para marcar "Me interesa" en este evento.',
    createAccount: "Crear cuenta",
    login: "Iniciar sesión",
  },
  en: {
    interested: "Interested",
    updateError: "Couldn't update. Please try again.",
    loginTitle: "Log in to mark your interest",
    loginDescription: 'Create a free account or log in to mark "Interested" on this event.',
    createAccount: "Create account",
    login: "Log in",
  },
});
